import React from "react";
import { compileTemplate } from "../chatInputUtils";
import { TemplatePart } from "../chatInputUtilsTypes";
import { ChatHighlight } from "./chatHighlight";
import { Highlight } from "./chatHighlighterTypes";

interface Props {
  text: string;
  parts: TemplatePart<Highlight>[];
}

export const ChatHighlighter = ({ text, parts }: Props) => {
  const template = compileTemplate([text], parts);

  return (
    <>
      {template.map((highlight, i) =>
        typeof highlight === "string" ? (
          <span key={i}>{highlight}</span>
        ) : (
          <ChatHighlight key={i} {...highlight.part} />
        )
      )}
    </>
  );
};
